
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zM2.4 12a9.6 9.6 0 1019.2 0 9.6 9.6 0 00-19.2 0z","fill":"#000","fill-opacity":".25"}}),_c('path',{attrs:{"d":"M24 12A12 12 0 1112 0v2.4a9.6 9.6 0 109.6 9.6H24z","fill":"#313131"}})])
          )
        }
      }
    